import React, { useEffect, useState } from "react";
import {
  Card, CardBody, CardHeader,
  Container, Row, Col, Button, FormGroup, Label, Input,
} from "reactstrap";
import { sessionRepo } from "data/repositories/sessionRepo";
import { roleLabel } from "labels/tr";

export default function ProfilePage() {
  const [session, setSession] = useState(null);
  const [displayName, setDisplayName] = useState("");

  useEffect(() => {
    const s = sessionRepo.getSession();
    setSession(s);
    if (s) setDisplayName(s.displayName || "");
  }, []);

  const handleSave = () => {
    if (!session) return;
    const updated = { ...session, displayName };

    sessionRepo.signIn({ ...updated });
    setSession(updated);
    alert("Profil güncellendi");
  };

  if (!session) {
    return (
      <>
        <div className="header bg-gradient-info pb-6 pt-5 pt-md-7" />
        <Container className="mt--6" fluid>
          <Card className="shadow">
            <CardBody className="text-center py-5">
              <h3>Giriş yapmadınız</h3>
              <p className="text-muted">Profil bilgilerinizi görmek için giriş yapın.</p>
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }

  return (
    <>
      <div className="header bg-gradient-info pb-6 pt-5 pt-md-7">
        <Container fluid>
          <h2 className="text-white mb-0">Profilim</h2>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row>
          <Col lg={8}>
            <Card className="shadow">
              <CardHeader><h3 className="mb-0">Profil Bilgileri</h3></CardHeader>
              <CardBody>
                <FormGroup>
                  <Label>Ad Soyad</Label>
                  <Input value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
                </FormGroup>
                <FormGroup>
                  <Label>E-posta</Label>
                  <Input value={session.email || ""} disabled />
                </FormGroup>
                <FormGroup>
                  <Label>Rol</Label>
                  <Input value={roleLabel(session.role || "customer")} disabled />
                </FormGroup>
                <Button color="primary" onClick={handleSave}>Kaydet</Button>
              </CardBody>
            </Card>
          </Col>

          <Col lg={4}>
            <Card className="shadow">
              <CardBody className="text-center">
                <div className="rounded-circle bg-gradient-primary text-white d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 80, height: 80, fontSize: 32 }}>
                  {(displayName || "K")[0].toUpperCase()}
                </div>
                <h4>{displayName}</h4>
                <p className="text-muted small">{session.email}</p>
                <Button
                  color="danger"
                  size="sm"
                  onClick={() => {
                    sessionRepo.signOut();
                    window.location.href = "/auth/login";
                  }}
                >
                  Çıkış yap
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
